// TermsAndConditions.jsx
import React from "react";
import { FileText } from "lucide-react";
import "./LegalPages.css";
import TestimonialsFaqFooter from "./TestimonialsFaqFooter";
import Footer from "./footer";

const TermsAndConditions = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <div className="legal-header">
          <div className="header-title">
            <FileText className="header-icon blue" />
            <h1>Terms & Conditions</h1>
          </div>
          <p className="breadcrumb">Home / Terms & Conditions</p>
        </div>

        <section className="legal-section">
          <div><h2>1. Acceptance of Terms</h2><p>By using the services of NextGen Prosperity Pvt. Ltd. including access to its website or platform for unlisted/pre-IPO shares, you agree to comply with these Terms and Conditions. If you do not agree, please refrain from using the services.</p></div>

          <div><h2>2. Eligibility and User Information</h2><ul><li>You confirm that all information you provide is true, accurate, and complete.</li><li>The Company reserves the right to verify information and suspend or terminate access for violations.</li></ul></div>

          <div><h2>3. Risk Disclosure and Investment Advisory</h2><ul><li>Investments in unlisted and pre-IPO shares carry inherent risks including lack of liquidity and market volatility.</li><li>The Company does not guarantee returns or future listing of any securities.</li><li>All investment decisions are your own; independent advice should be sought.</li></ul></div>

          <div><h2>4. Compliance and Regulatory Obligations</h2><ul><li>You agree to comply with applicable Indian laws, including SEBI regulations, FEMA, and KYC norms.</li><li>You must provide all necessary documentation for verification.</li></ul></div>

          <div><h2>5. Account Security and Responsibility</h2><ul><li>You are responsible for keeping your account credentials confidential.</li><li>Any activity via your account is your responsibility.</li><li>Notify the company immediately of any unauthorized account access.</li></ul></div>

          <div><h2>6. Intellectual Property and Use of Platform</h2><ul been><li>All content and materials on the platform are protected by intellectual property laws.</li><li>Unauthorized use or reproduction without permission is prohibited.</li></ul></div>

          <div><h2>7. Conflict of Interest and Ethical Conduct</h2><ul><li>Employees and affiliates are bound by strict conflict of interest rules.</li><li>Confidential and non-public information must not be used for trading or personal gain.</li><li>Gifts, benefits, or entertainment linked to business advantage are strictly regulated.</li></ul></div>

          <div><h2>8. Data Privacy and User Rights</h2><ul><li>The Company respects your data privacy per the Privacy Policy.</li><li>You have rights to access, correct, delete, or restrict your personal data.</li></ul></div>

          <div><h2>9. Limitation of Liability</h2><ul><li>The Company is not liable for investment losses, indirect damages, or service interruptions.</li><li>Services are provided "as is" without warranties.</li></ul></div>

          <div><h2>10. Reporting and Whistleblowing</h2><p>Employees are encouraged to report unethical or illegal conduct without fear of retaliation.</p></div>

          <div><h2>11. Governing Law and Dispute Resolution</h2><ul><li>These Terms are governed by Indian law.</li><li>Any disputes will be subject to the jurisdiction of courts in the company's registered city.</li></ul></div>

          <div><h2>12. Amendments</h2><ul><li>The Company may update Terms & Conditions at any time.</li><li>Continued use after changes signifies acceptance.</li></ul></div>
        </section>
      </div>
       <Footer />
    </div>
  );
};

export default TermsAndConditions;